module.exports = __webpack_public_path__ + "img/sx.4842384f.jpg";